export default __webpack_public_path__ + "static/media/BlueRegular.23415f46.png";